import CreateCopyTemplateForm from './CreateCopyTemplateFormLazy'
import { CreateCopyTemplateFormProps } from './CreateCopyTemplateForm'
export type { CreateCopyTemplateFormProps }
export default CreateCopyTemplateForm
